/**
 * Catalogo novità prodotto HeyJob (company).
 * Per ogni voce: creare content/{slug}.md e aggiungere metadati qui.
 */
export const RELEASE_CATALOG = [
  {
    slug: 'documenti-firma-2026-06',
    title: 'Documenti Autogenerati e Firma Elettronica',
    summary:
      'Genera PDF dai tuoi modelli con dati precompilati e firma i documenti direttamente dalla dashboard tramite OTP.',
    publishedAt: '2026-06-03T09:00:00.000Z',
    featured: true,
    version: '1.5.0',
    videoId: '5453fb2f56e5d1609416a2123f2c01d5',
  },
];
